/* Joe Luxe extras — additive only, on top of the theme's own cart and pages.
   1. Add-to-bag moment: after a successful add, a small copy of the piece glides
      into the bag icon and the count pops. Nothing flies if the add failed.
   2. Recently viewed: product pages remember the piece (this browser only);
      any [data-jl-recent] strip lists the last few, newest first. */
(function () {
  if (window.__jlExtras) return;
  window.__jlExtras = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Add-to-bag moment ---------- */
  var pending = null; /* { img, rect, at } from the last Add to cart tap */

  function visible(r) {
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function sourceFor(btn) {
    var card = btn.closest('product-card, .product-card');
    var img = card && card.querySelector('img');
    if (!img) {
      var slides = document.querySelectorAll('media-gallery .product-media img');
      for (var i = 0; i < slides.length; i++) {
        if (visible(slides[i].getBoundingClientRect())) { img = slides[i]; break; }
      }
      img = img || slides[0];
    }
    if (!img) return null;
    var r = img.getBoundingClientRect();
    if (!visible(r)) {
      /* photo scrolled away (e.g. the slim bar was used): start from the button */
      var b = btn.getBoundingClientRect();
      var s = Math.min(72, b.height * 1.4);
      r = { left: b.left + 12, top: b.top + (b.height - s) / 2, width: s, height: s };
    }
    return { src: img.currentSrc || img.src, rect: r };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, .jl-pdp-bar__btn, [name="add"]');
    if (!btn || btn.disabled) return;
    /* the slim bar forwards its tap to the main button: keep the bar's start point */
    if (pending && Date.now() - pending.at < 120) return;
    pending = sourceFor(btn);
    if (pending) pending.at = Date.now();
  }, true);

  function bagIcon() {
    var icons = document.querySelectorAll('.header-actions__cart-icon, cart-icon');
    for (var i = 0; i < icons.length; i++) {
      if (visible(icons[i].getBoundingClientRect())) return icons[i];
    }
    return null;
  }

  function pop(icon) {
    icon.classList.remove('jl-bag-pop');
    void icon.offsetWidth; /* restart the animation */
    icon.classList.add('jl-bag-pop');
    setTimeout(function () { icon.classList.remove('jl-bag-pop'); }, 700);
  }

  function fly(from, icon) {
    var t = icon.getBoundingClientRect();
    var r = from.rect;
    var size = Math.min(r.width, r.height, 160);
    var x0 = r.left + (r.width - size) / 2;
    var y0 = r.top + (r.height - size) / 2;
    var dx = t.left + t.width / 2 - (x0 + size / 2);
    var dy = t.top + t.height / 2 - (y0 + size / 2);
    var end = 22 / size;

    var el = document.createElement('img');
    el.className = 'jl-fly';
    el.src = from.src;
    el.alt = '';
    el.style.width = el.style.height = size + 'px';
    el.style.left = x0 + 'px';
    el.style.top = y0 + 'px';
    document.body.appendChild(el);

    var anim = el.animate(
      [
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
        { transform: 'translate3d(' + dx * 0.45 + 'px,' + (dy * 0.45 - 60) + 'px,0) scale(' + (0.55 + end * 0.45) + ')', opacity: 1, offset: 0.45 },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + end + ')', opacity: 0.2 }
      ],
      { duration: 650, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' }
    );
    anim.onfinish = function () {
      el.remove();
      pop(icon);
    };
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    var from = pending;
    pending = null;
    if (!from || d.didError || Date.now() - from.at > 6000) return;
    var icon = bagIcon();
    if (!icon) return;
    if (reduce) pop(icon);
    else fly(from, icon);
  });

  /* ---------- 2. Recently viewed ---------- */
  var KEY = 'jl-recent';
  var KEEP = 12;
  var MAX_AGE = 30 * 24 * 3600 * 1000;

  function load() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      var now = Date.now();
      return Array.isArray(list) ? list.filter(function (p) { return p && p.url && now - (p.t || 0) < MAX_AGE; }) : [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP))); } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function recent() {
    var strips = document.querySelectorAll('[data-jl-recent]');
    if (!strips.length) return;
    var list = load();

    /* A product page's strip carries the current piece: remember it */
    var current = null;
    Array.prototype.forEach.call(strips, function (s) {
      var raw = s.getAttribute('data-jl-current');
      if (!raw || current) return;
      try { current = JSON.parse(raw); } catch (e) {}
    });
    if (current && current.url) {
      list = list.filter(function (p) { return p.url !== current.url; });
      current.t = Date.now();
      list.unshift(current);
      save(list);
    }

    Array.prototype.forEach.call(strips, function (s) {
      var show = list.filter(function (p) { return !current || p.url !== current.url; }).slice(0, +s.getAttribute('data-jl-recent') || 8);
      var track = s.querySelector('.jl-recent__track');
      if (!track || show.length < 2) return; /* stays hidden until there is something worth showing */
      track.innerHTML = show.map(function (p) {
        return (
          '<li class="jl-recent__item"><a class="jl-recent__link" href="' + esc(p.url) + '">' +
          '<span class="jl-recent__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
          (p.sku ? '<span class="jl-recent__code">' + esc(p.sku) + '</span>' : '') +
          '<span class="jl-recent__name">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="jl-recent__price">' + esc(p.price) + '</span>' : '') +
          '</a></li>'
        );
      }).join('');
      s.hidden = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', recent);
  else recent();
})();
